import { Component } from '@angular/core';

@Component({
    templateUrl: './startpage.component.html',
    styleUrls: ['./startpage.component.css'],
})
export class StartpageComponent {
}
